<template>
  <div id="app">
    <server-unavailable v-if="serverUnavailable"/>

    <div v-else-if="!load && !acesso" class="container-acesso">
      <div>
        <h5 class="font-weight-bold">Fora de expediente!</h5>
        <p>Você pode acessar o sistema apenas dentro do seu horário de serviço. Clique no botão abaixo para realizar uma nova tentativa.</p>
        <div class="mb-5">
          <a href="/" class="btn btn-primary">Tentar novamente</a>
        </div>
        <hr>
        <div>
          <div class="small">Usuário: {{user.email}}</div>
          <div class="small">Se for um engano por favor verifique com um administrador do seu sistema</div>
        </div>
      </div>
    </div>
    <div v-else-if="!load">
      <router-view/>
    </div>

    <loading full="true" :text="msgServer" v-else/>

    <modal-fila ref="fila" :token="token" :printServer="printServer" @checkIfood="checkIfood()"/>
    <modal-chat v-if="user.id_empresa"/>

    <div class="modal modal-loading d-block" v-if="loadingGeral" style="z-index: 99999">
      <div class="modal-content border-0">
        <div style="padding: 24px 6px 32px">
          <loading :text="loadingGeral" :ellipsis="true"/>
        </div>
      </div>
    </div>

    <div v-if="chatIfood" class="ifood-widget">
      <div class="widget-content shadow-lg">
        <a href="https://widgets.ifood.com.br/" target="_blank" title="Abrir chat do iFood">
          <img alt="iFood" src="./assets/icons/ifood-light.svg">
        </a>
      </div>
    </div>

  </div>
</template>

<script>
  import Vue from "vue";
  import ModalFila from "./components/gestor/ModalFilaImpressao";
  import Loading from "@/components/gestor/loading";
  import ModalChat from "@/components/gestor/ModalChat";
  import ServerUnavailable from "@/components/commons/ServerUnavailable";

  export default {
    components: {ServerUnavailable, ModalChat, Loading, ModalFila},
    data() {
      return {
        load: true,
        token: localStorage.getItem('key'),
        empresas: [],
        user: {},
        printServer: false,
        printConfig: {},
        silenciar: false,
        pIfood: null,
        integracoes: [],
        audio_chat: null,
        audio_msg: null,
        acesso: true,
        x_auth: '',
        serverUnavailable: false
      }
    },
    name: 'App',
    methods: {
      autenticar() {
        const cacheUser = this.$cache.get("usuario");

        if (cacheUser) {
          this.setTokenServer(cacheUser.x_auth);
          this.autenticarEmpresas(cacheUser);
        }

        this.$http.post(this.base_server + 'auth/v2/me', { token: this.token })
          .then(res => {
            if (res.data.success) {
              this.$cache.set("usuario", res.data);

              if (!cacheUser) {
                this.setTokenServer(res.data.x_auth);
                this.$nextTick(() => {
                  this.autenticarEmpresas(res.data);
                });
              }

            } else {
              this.$swal("Não conseguimos autenticar sua empresa. Por favor tente novamente.");
              this.load = false;
            }

          }, res => {
            if (!res.status) {
              this.serverUnavailable = true;

            } else if (res.status === 401) {
              this.load = false;
              this.$cache.resetAll();
              localStorage.removeItem('key');
              this.$swal("Por favor faça o login novamente.");

              if (this.$route.name !== 'Login') {
                this.$router.push('/');
              }

            } else {
              this.$store.state.msgServer = "No momento este canal está indisponível.\nPor favor verifique se sua conexão está estável."
            }
          });
      },

      setTokenServer(auth) {
        this.x_auth = auth ? `Bearer ${auth}` : null;
        localStorage.setItem("x_auth", this.x_auth);

        if (this.x_auth) {
          this.$store.state.x_auth = this.x_auth;
        }
      },

      configReadOnly() {
        const isRead = (!!window.isReadOnly || !!sessionStorage.getItem('isReadOnly'));

        if (!['1','2'].includes(this.user.id_funcao) || isRead) {
          this.$store.commit('setReadOnly', sessionStorage.getItem('isReadOnly') || true);
        }
      },

      setImpressora(user, token) {
        this.printConfig = user.printConfig ? JSON.parse(user.printConfig) : { automatico: "0", nCopias: "1", zoom: "9px", device: "", devicePdv: "", largura: "", printCashier: "0", printCashierPdv: "0" };

        if (this.isElectron && (!user.printConfig || !this.printConfig.printServer)) {
          if (!user.printConfig || !user.printConfig.printServer) {
            this.printConfig.printServer = (window.gPConfigs || {}).host || null;
          }

          this.$http.post('delivery/config/' + token, { printConfig: JSON.stringify(this.printConfig) })
            .then(res => {
              if (res.data && res.data.success) {
                this.$swal("Configurações atualizadas com sucesso!");

              } else {
                this.$swal('Erro ao atualizar as configurações!');
              }

            }, res => {
              this.load = false;
              if (res.data.msg) {
                this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
              }
            });
        }

        this.printConfig.printCashier = (localStorage.getItem('printCashier') || this.printConfig.printCashier || '0') === '1';
        this.printConfig.printCashierPdv = (this.printConfig.printCashierPdv === '1');
        this.printConfig.mobilePrint = (this.printConfig.mobilePrint === '1' && !this.isElectron);
        this.$store.state.impressora = this.printConfig;
        this.setImpressoraLocal();
      },

      setImpressoraLocal() {
        const comprovanteLocal = this.$helpers.parseJSONObject(localStorage.getItem('receiptPrinterLocal')) || {};
        const modoComprovante = localStorage.getItem('receiptPrinterMode') ||
          ((Number(localStorage.getItem('printMode') || 1) === 2 || comprovanteLocal.device) ? 'local' : 'remote');

        this.$store.commit('setImpressoraComprovanteLocal', {
          ...comprovanteLocal,
          modo: modoComprovante
        });

        if (localStorage.getItem('impressoraPdv')) {
          this.$store.state.impressora.devicePdv = localStorage.getItem('impressoraPdv');
        }

        if (localStorage.getItem('impressoraPedidos')) {
          this.$store.state.impressora.device = localStorage.getItem('impressoraPedidos');
        }

        if (this.isElectron && !localStorage.getItem('printRemoto')) {
          this.$store.state.printLocal = true;
        }
      },

      autenticarEmpresas(data) {
        this.user = data.dados;

        if (this.user.status_empresa !== '2') {
          this.$store.state.is_block = true;

          if (this.$route.name !== 'Block') {
            this.$router.push('/block');
          }

          this.load = false;
          return;

        } else if ((this.user.is_beta === '1' && !this.is_beta) || (this.isElectron && this.is_beta && this.user.is_beta !== '1')) {
          if (this.$route.name !== 'Ambiente') {
            this.$router.push('/ambiente');
          }

          this.load = false;
          return;
        }

        this.$store.commit('setDataUser', data);
        localStorage.setItem("key", this.token);
        localStorage.setItem("token", data.empresa);
        document.dispatchEvent(new CustomEvent('setEmpresa', { detail: this.user }));

        this.setImpressora(this.user, this.token);
        this.configReadOnly();
        this.acesso = !!data.horario_acesso;

        data.integracoes.filter(i => ['2','4','16','18'].includes(i.plataforma)).forEach(i => {
          this.integracoes.push({
            token: this.token,
            id_auth: i.id_auth,
            id_empresa: i.id_empresa,
            empresaToken: i.token,
            nome_fantasia: i.nome_fantasia,
            fg_ativo: i.fg_ativo,
            merchantId: i.key1,
            title: null,
            description: 'Aguarde..',
            available: false,
            validations: [],
            plataforma: i.plataforma
          });
        });

        const bandeiras = (data.bandeiras || []);
        this.empresas = bandeiras.length ? bandeiras.map(e => { return { ...e, key: this.token}})
            : [{ id_empresa: this.user.id_empresa, key: this.token, token: data.empresa, configs: null, nome_fantasia: this.user.nome_fantasia }];
        this.$store.state.empresas = this.empresas;

        if (this.$socket) {
          this.empresas.forEach(e => {
            this.$socket.emit('empresa_connected', e.token);
          });
        }

        let url_path = this.isReadOnly ? '/home' : (this.isComanda || (this.is_mobile && this.user.habilitar_comanda === '1') ? '/home' : '/pedidos');

        if (this.isReadOnly && localStorage.getItem('isTerminal')) {
          url_path = '/terminal';
        }

        this.silenciar = this.isReadOnly || localStorage.getItem('silenciar') === '1' || this.isComanda;
        const pilotoAutomatico = localStorage.getItem('pilotoAutomatico') === '1';

        if ((this.$route.name === 'Login' || this.isReadOnly) && this.$route.path !== url_path) {
          this.$router.push(url_path);
        }

        if (this.isElectron) {
          this.$store.state.canPlay = !this.silenciar;
          this.buscarPedidosStatus();
          const isPrintServer = !localStorage.getItem('unPrintPdv') && (window.gPConfigs || {}).host === this.printConfig.printServer;

          // servidor de impressao
          if (isPrintServer) {
            this.printServer = true;
            this.$store.state.printLocal = true;
            this.$store.state.printServer = true;
            this.$store.state.pilotoAutomatico = pilotoAutomatico;
          }
        }

        if (!this.printServer) {
          if (localStorage.getItem('showPiloto') === '1') {
            this.$store.state.pilotoAutomatico = pilotoAutomatico;
          }
        }

        const merchantIds = this.pollingIfood();
        this.$store.state.integracoes = this.integracoes;
        document.dispatchEvent(new CustomEvent('getPrinters'));

        this.$req.buscarDados(this, this.user.id_empresa, (this.user.habilitar_comanda !== '1'), (res) => {
          this.load = false;

          if (!res) {
            if (this.$route.name !== 'Version') {
              this.$router.push('/versao');
            }

            return;
          }

          this.$refs.fila.getFilaImpressao(this.printServer);
          const showChatIfood = localStorage.getItem('hideChatIfood') !== '1';

          if (this.isElectron && merchantIds.length && !this.isReadOnly && showChatIfood) {
            document.dispatchEvent(new CustomEvent('ifoodWidget'));
          }

          if (!this.isElectron && !this.silenciar && (!this.is_mobile || this.$route.name === 'Pedidos') && this.acesso) {
            this.$swal({
              text: 'Ação necessária para ativar o som das notificações',
              button: "Inicializar agora"
            }).then((r) => {
              this.$store.state.canPlay = true;
              this.buscarPedidosStatus();
            });
          }
        });
      },

      buscarPedidosStatus() {
        const isPedido = ['Pedidos', 'Monitor', 'KdsGestor', 'Terminal', 'AutoTerminal'].includes(this.$route.name) || this.$route.path.startsWith('/pdv');

        if (this.silenciar || isPedido || !this.token) {
          return;
        }

        this.$http.get(`v2/pedidos/status?key=${this.token}`)
          .then(response => {
            if (response && response.data) {
              const pendentes = response.data.pendentes;

              if (pendentes > 0) {
                this.$store.commit('setBell', pendentes);

                if (this.$store.state.canPlay) {
                  this.playNotification();
                }

              } else {
                this.$store.commit('setBell', false);
                this.pauseNotification();
              }
            }

          }, res => {
            console.log(res);
          });
      },

      ifoodReply(e) {
        if (!e.detail) {
          return;
        }

        if (e.detail.error) {
          this.$store.state.statusIfood = false;
          this.$store.commit('addOcorrencia', {
            tipo: '3',
            titulo: 'iFood',
            id_informe: e.detail.errorCode || null,
            texto_informe: (e.detail.error || '').substring(0, 128)
          });

        } else if (e.detail.event) {
          const event = JSON.parse(e.detail.event);
          let texto_informe = null;
          let titulo = null;
          let alerta = null;

          switch (event.code) {
            case "CAN":
              titulo = "iFood - Pedido cancelado"
              texto_informe = `Um pedido foi cancelado pelo seguinte motivo: ${(event.metadata || {}).CANCEL_REASON || ''}`;
              break;

            case "HSD":
              const metadata = event.metadata || {};
              const date = new Date(metadata.expiresAt || '');
              const hour = String(date.getHours()).padStart(2,'0');
              const minute = String(date.getMinutes()).padStart(2,'0');
              titulo = "iFood - ";

              switch (metadata.handshakeType) {
                case "PREPARATION_TIME":
                  titulo += "Solicitação de cancelamento";
                  break;

                case "AFTER_DELIVERY":
                  titulo += "Problemas com pedido entregue";
                  break;

                case "DELAY":
                  titulo += "Problemas com pedido";
                  break;

                case "AFTER_DELIVERY_PARTIALLY":
                  titulo += "Solicitação de cancelamento";
                  break;

                default:
                  titulo += "Nova solicitação"
              }

              texto_informe = `Motivo: ${metadata.message || 'Sem motivos'}`;
              alerta = `Acesse o Gestor do iFood (ou Widget) para responder. Horário limite: <b>${hour}:${minute}</b> ou o pedido poderá ser cancelado sem uma consulta.`;
              break;
          }

          if (texto_informe) {
            this.$store.commit('addOcorrencia', {
              tipo: '3',
              id_ifood: event.order_id,
              id_informe: null,
              texto_informe,
              alerta,
              titulo
            });
          }

        } else {
          this.$store.state.statusIfood = true;
          this.pIfood = new Date().getTime();
          const merchantId = e.detail.merchantId || null;
          const orders = e.detail.orders || [];
          const status = e.detail.status || [];
          const count = e.detail.count;

          if (status.length) {
            const statusIfood = status[0];
            this.$store.state.integracoes.forEach(i => {
              if (i.plataforma === '2' && (!merchantId || merchantId === i.merchantId)) {
                i.title = statusIfood.message.title;
                i.description = statusIfood.message.subtitle;
                i.available = statusIfood.available;
                i.validations = statusIfood.validations;
              }
            });
          }

          if (this.$store.state.logsIfood) {
            console.log(count, 'pedidos', orders);
            console.log(count, 'status', status);
          }
        }
      },

      newMessage(event) {
        if (event.origin !== process.env.VUE_APP_CHAT) return;
        this.$store.state.chats = (Array.isArray(event.data) ? event.data : []);
      },

      pollingIfood() {
        const integracoesIfood = this.integracoes.filter(i => i.plataforma === '2' && i.fg_ativo === '1');
        const merchantIds = integracoesIfood.map(i => i.merchantId);

        if (!integracoesIfood.length) return merchantIds;

        if (!this.printServer) {
          integracoesIfood.forEach(i => {
            i.title = null;
            i.description = 'Confira o status da sua loja no Gestor Principal';
          });

          return merchantIds;
        }

        this.$store.state.ifoodAtivo = true;

        if (localStorage.getItem('ifoodPollingV2') === '1') {
          const merchants = integracoesIfood.map(i => ({ id_auth: i.id_auth, merchantId: i.merchantId }));

          document.dispatchEvent(new CustomEvent('ifoodPollingV2', {
            detail: { x_auth: this.x_auth, base_ifood: this.base_server, merchants }
          }));

          return merchantIds;
        }

        integracoesIfood.forEach((i, index) => {
          setTimeout(() => {
            if (localStorage.getItem('ifoodPollingV2') === '1') return;
            document.dispatchEvent(new CustomEvent('ifoodPolling', {
              detail: { token: i.token, merchantId: i.merchantId, id_empresa: i.id_empresa, base_api: this.base_server, x_auth: this.x_auth }
            }));
          }, index * 1500);
        });

        return merchantIds;
      },

      checkIfood() {
        if (this.$store.state.ifoodAtivo) {
          if (!this.pIfood || (new Date().getTime() - this.pIfood) > 3 * 60000) {
            this.$store.state.statusIfood = false;
            this.pollingIfood();
          }
        }
      },

      setPrinters(e) {
        const printers = e.detail || [];
        this.$store.state.printers = printers;
        sessionStorage.setItem('Printers', JSON.stringify(printers));
      },

      setIfoodWidget(res) {
        const status = res.detail?.status;
        this.$store.state.chatIfood = !(status === 'started' || status === 'running');
      },

      carregarAudios() {
        this.$audio.load("pedidos", localStorage.getItem("som_pedidos") || "bell", true);
        this.$audio.load("notificacao", localStorage.getItem("som_notificacao") || "bell-4");

        this.$audio.onError(({ name }) => {
          this.$swal(`Não foi possível carregar/tocar o áudio: ${name}`);
        });
      }
    },

    async mounted() {
      localStorage.removeItem('x_auth');
      this.token = localStorage.getItem('key') || null;
      this.$store.state.is_mobile = this.is_mobile;

      if (window.location.search) {
        const cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
        window.history.replaceState({}, '', cleanUrl);
      }

      if (this.token) {
        const server = await this.resolveServer();

        if (server.reloading) {
          return;
        }

        if (!server.server_available) {
          this.serverUnavailable = true;
          return;
        }

        this.$store.state.session = this.$helpers.ID();
        this.$store.state.logsIfood = localStorage.getItem('logsIfood') === '1';
        this.$store.state.isTerminal = localStorage.getItem('isTerminal') || '';
        localStorage.removeItem('alertas');
        this.$store.state.ocorrencias = this.$helpers.parseJSONObject(localStorage.getItem('ocorrencias')) || [];
        this.$store.state.novidades = parseInt(sessionStorage.getItem('novidades') || '0');
        const configsLocal = this.$helpers.parseJSONObject(localStorage.getItem('configsLocal'));
        this.$store.state.configsLocal = configsLocal || this.$store.state.configsLocal;
        this.$store.state.msgServer = "Autenticando..";
        this.autenticar();

      } else {
        localStorage.removeItem('token');

        if (this.$route.name !== 'Login') {
          this.$router.push('/');
        }

        setTimeout(() => {
          this.load = false;
        }, 1000);
      }
    },

    created() {
      this.carregarAudios();

      if (this.isElectron) {
        document.addEventListener("ifoodReply", this.ifoodReply, false);
        document.addEventListener("setPrinters", this.setPrinters, false);
        document.addEventListener("setIfoodWidget", this.setIfoodWidget, false);

        if (localStorage.getItem('acbrFolder')) {
          window.acbrFolder = localStorage.getItem('acbrFolder');
        }
      }

      setTimeout(() => {
        this.$store.state.isReady = true;
      }, 30000);

      window.addEventListener("message", this.newMessage);
    },

    beforeDestroy() {
      document.removeEventListener('ifoodReply', this.ifoodReply);
      document.removeEventListener('setPrinters', this.setPrinters);
      document.removeEventListener('setIfoodWidget', this.setIfoodWidget);
      window.removeEventListener('message', this.newMessage)
    },

    sockets: {
      connect() {
        if (this.token && this.$store.state.isReady) {
          this.empresas.forEach(e => {
            this.$socket.emit('empresa_connected', e.token)
          });

          if (this.printServer) {
            this.$refs.fila.getFilaImpressao(true);
          }
        }
      },

      delivery_order() {
        this.buscarPedidosStatus();
      },

      print() {
        if (this.printServer) {
          this.$refs.fila.getFilaImpressao(true);
        }
      },

      new_chat(data) {
        if (!this.$store.state.modalChat && data && !this.is_mobile) {
          const id = data.id_chat.toString();

          if (!this.$store.state.chats.includes(id)) {
            this.$store.state.chats.push(id);
          }

          if (data.novo_chat) {
            if (!this.audio_chat) {
              this.audio_chat = new Audio("https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-gestor/new-chat.mp3");
            }

            if (this.$store.state.canPlay && this.audio_chat && this.audio_chat.paused) {
              this.audio_chat.play();
            }

            if (this.isElectron && "Notification" in window) {
              new Notification('Chat de Pedidos', {
                body: `Nova solicitação de atendimento`,
                icon: './icon.png'
              });
            }

          } else {
            if (!this.audio_msg) {
              this.audio_msg = new Audio("https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-gestor/new_msg.mp3");
            }

            if (this.$store.state.canPlay && this.audio_msg && this.audio_msg.paused) {
              this.audio_msg.play();
            }

            if (this.isElectron && "Notification" in window) {
              new Notification('Nova mensagem', {
                body: `${data.mensagem || ''}`,
                icon: './icon.png'
              });
            }
          }
        }
      }
    },

    computed: {
      loadingGeral() {
        return this.$store.state.load;
      },

      isReadOnly() {
        return this.$store.state.isReadOnly;
      },

      isComanda() {
        return this.$store.state.is_comanda;
      },

      msgServer() {
        return this.$store.state.msgServer;
      },

      chatIfood() {
        return this.$store.state.chatIfood;
      }
    }
  }
</script>
<style scoped>
  .container-acesso {
    max-width: 500px;
    padding: 0 15px;
    height: 95vh;
    margin: auto;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ifood-widget {
    text-align: right;
    position: fixed;
    bottom: 36px;
    right: 32px;
  }

  .ifood-widget .widget-content {
    margin-top: -4px;
    width: 72px;
    height: 72px;
    background-color: #EA232B;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ifood-widget img {
    width: 44px;
  }
</style>
